import { VOCE_A_PAGINA } from "./sottopagine";

export const MENU_SERVIZI = [
  {
    nome: "Elettricista",
    slug: "elettricista",
    voci: [
      "Cortocircuito e salvavita",
      "Guasti e black-out",
      "Quadri elettrici",
      "Prese e interruttori",
      "Ripristino corrente",
    ],
    pagine: VOCE_A_PAGINA.elettricista,
  },
  {
    nome: "Fabbro",
    slug: "fabbro",
    voci: [
      "Apertura porte bloccate",
      "Cambio serrature",
      "Serrande e tapparelle",
      "Cancelli e inferriate",
      "Chiave rotta nella serratura",
    ],
    pagine: VOCE_A_PAGINA.fabbro,
  },
  {
    nome: "Idraulico",
    slug: "idraulico",
    voci: [
      "Perdite d'acqua",
      "Stasatura tubi intasati",
      "Allagamenti",
      "Rubinetteria e sanitari",
      "Scaldabagno e boiler",
    ],
    pagine: VOCE_A_PAGINA.idraulico,
  },
];

export const SERVIZIO_SELECT_MAP = {
  elettricista: "Elettricista",
  fabbro: "Fabbro e serrature",
  idraulico: "Pronto intervento idraulico",
};

export const slugifyVoce = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-");
